import { useEffect, useState } from 'react'

import { useRoute } from '@react-navigation/native'
import { Stack, XStack, colors } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import Close from '@zet/design-system/svg/Close'
import Filter from '@zet/design-system/svg/Filter'
import DateFilter from '@zet/feature-earnings/src/components/earningsFilter/dateFilter'
import { teamEarningsFilters } from '@zet/my-teams/src/utils/constants'
import { isEmpty } from 'lodash'

import { IMyTeamsEarningsFiltersDTO } from '../../../api/earnings/types'
import EarningsFilterTab from './earningsFilterTab'

type EarningsFiltersProps = {
  filters: IMyTeamsEarningsFiltersDTO
  setFilters: (filters: IMyTeamsEarningsFiltersDTO) => void
  handleClearFilter: () => void
}

const EarningsFilters = ({
  filters,
  setFilters,
  handleClearFilter,
}: EarningsFiltersProps) => {
  const _filtersData = teamEarningsFilters.filter((f) => f.name != 'teams')
  const { params }: { params: { earningType: string } } = useRoute<any>()
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const removeStartAndEndDate = () => {
    if (filters.startDate && filters.endDate) {
      const { startDate, endDate, ...restFilters } = filters
      return restFilters
    }
    return filters
  }

  useEffect(() => {
    setDateRange()
  }, [startDate, endDate])

  const setDateRange = () => {
    if (startDate && endDate) {
      setFilters({ ...filters, startDate, endDate })
    } else {
      setFilters({ ...removeStartAndEndDate() })
    }
  }

  const checkIfFilterIsSelected = () => {
    if (!isEmpty(Object.values(filters))) {
      const nonEmptyValues = Object.values(filters).filter((v) => !isEmpty(v))
      if (nonEmptyValues.length > 0) {
        return true
      } else {
        return false
      }
    }
    return false
  }

  return (
    <XStack className="mx-3 mt-1 items-center">
      <Stack className="border-grays-40 my-2 items-center justify-center rounded border px-2 py-1">
        {checkIfFilterIsSelected() ? (
          <Pressable onPress={() => handleClearFilter()}>
            <Close size={18} color={colors.neutral.black100} />
          </Pressable>
        ) : (
          <Filter size={18} color={colors.grays[70]} />
        )}
      </Stack>
      <DateFilter
        startDate={filters.startDate || ''}
        endDate={filters.endDate || ''}
        setEndDate={setEndDate as React.Dispatch<React.SetStateAction<string>>}
        setStartDate={
          setStartDate as React.Dispatch<React.SetStateAction<string>>
        }
        screenName={params.earningType}
      />
      {_filtersData.map((filter, index) => {
        return (
          <EarningsFilterTab
            filters={filters}
            setFilters={setFilters}
            filterLabel={filter.label}
            filterIcon={filter.icon}
            filterName={filter.name}
            key={index}
            type={filter.type}
          />
        )
      })}
    </XStack>
  )
}

export default EarningsFilters
